import {
  gatewayHistoryUrl,
  HISTORY_DEFAULT_ORDER,
  HISTORY_PAGE_SIZE,
} from '../const'
import { HistoryListLoadPayload, HistoryListRequest } from './types'

export const buildHistoryQuery = ({
  gatewayId,
  internalName,
  status,
  sorterField = HISTORY_DEFAULT_ORDER,
  page = '1',
  pageSize = String(HISTORY_PAGE_SIZE),
}: HistoryListRequest): Record<string, string> => {
  const where: Record<string, string | boolean> = {}

  if (gatewayId) where.gatewayId = gatewayId
  if (internalName) where.internalName = internalName
  if (status === 'blocked') where.isBlocked = true
  if (status === 'active') where.isBlocked = false

  const query: Record<string, string> = {
    page,
    limit: pageSize,
    order: sorterField,
  }

  if (Object.keys(where).length > 0) query.where = JSON.stringify(where)

  return query
}

// Shared by the initial load and by the refetch after a status change, so the
// two can never drift apart.
export const toHistoryRequest = ({
  clientId,
  ...request
}: HistoryListLoadPayload) => ({
  url: gatewayHistoryUrl(clientId),
  query: buildHistoryQuery(request),
})
